/** Public address search (all self-help addresses); also the base of every address detail route. */
export const ORGANIZATION_LIST_ROUTE = '/main/organizations/selfHelpAddress/all';
